export default __webpack_public_path__ + "static/media/rounded-bag.2cb9784a.webp";